/* Tender Nectar — theme.js */
(function () {
  'use strict';

  /* ---------- Money formatting (uses the shop's money format string) ---------- */

  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = (number / 100).toFixed(precision).split('.');
      var units = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return units + (parts[1] ? decimal + parts[1] : '');
    }

    var value;
    switch ((format.match(placeholderRegex) || [])[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  /* ---------- Buy box: variant + bundle selection ---------- */

  document.querySelectorAll('[data-buybox]').forEach(function (box) {
    var dataEl = box.querySelector('[data-variants-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var moneyFormat = box.getAttribute('data-money-format') || '${{amount}}';
    var idInput = box.querySelector('[data-variant-id]');
    var qtyInput = box.querySelector('[data-quantity-input]');
    var priceEl = box.querySelector('[data-price]');
    var compareEl = box.querySelector('[data-compare-price]');
    var saveEl = box.querySelector('[data-save-badge]');
    var atcBtn = box.querySelector('[data-atc-button]');
    var atcLabel = atcBtn ? (atcBtn.getAttribute('data-label') || atcBtn.textContent) : '';
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var bundleInputs = box.querySelectorAll('[data-bundle-input]');
    var bundlePrices = box.querySelectorAll('[data-bundle-price]');
    var stockNote = box.querySelector('[data-stock-note]');
    var stockText = box.querySelector('[data-stock-text]');

    /* ensure one bundle option is selected */
    if (bundleInputs.length) {
      var anyChecked = Array.prototype.some.call(bundleInputs, function (i) { return i.checked; });
      if (!anyChecked) bundleInputs[0].checked = true;
    }

    function currentQty() {
      var checked = box.querySelector('[data-bundle-input]:checked');
      return checked ? Math.max(1, parseInt(checked.value, 10) || 1) : 1;
    }

    function currentSelection() {
      var opts = [];
      box.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    function update() {
      var variant = findVariant(currentSelection());
      if (!variant) return;

      var qty = currentQty();
      var totalCents = variant.price_cents * qty;
      /* qty 1 uses the server-rendered exact string; multiples are formatted client-side */
      var totalText = qty === 1 ? variant.price : formatMoney(totalCents, moneyFormat);

      if (idInput) idInput.value = variant.id;
      if (qtyInput) qtyInput.value = qty;
      if (priceEl) priceEl.textContent = totalText;
      if (stickyPrice) stickyPrice.textContent = totalText;

      var onSale = variant.compare_at && variant.compare_at_cents > variant.price_cents;
      if (compareEl) {
        compareEl.textContent = onSale
          ? (qty === 1 ? variant.compare_at : formatMoney(variant.compare_at_cents * qty, moneyFormat))
          : '';
        compareEl.style.display = onSale ? '' : 'none';
      }
      if (saveEl) {
        if (onSale) {
          var pct = Math.round((1 - variant.price_cents / variant.compare_at_cents) * 100);
          saveEl.textContent = 'SAVE ' + pct + '%';
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }

      /* per-tile totals */
      bundlePrices.forEach(function (el) {
        var q = Math.max(1, parseInt(el.getAttribute('data-qty'), 10) || 1);
        el.textContent = q === 1 ? variant.price : formatMoney(variant.price_cents * q, moneyFormat);
      });

      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = atcLabel;
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Sold out';
        }
      }

      /* honest low-stock note: only when inventory-tracked and actually low */
      if (stockNote && stockText) {
        var threshold = parseInt(stockNote.getAttribute('data-threshold'), 10) || 8;
        var low = variant.managed && variant.available && variant.policy !== 'continue' &&
                  variant.inv > 0 && variant.inv <= threshold;
        if (low) {
          stockText.textContent = 'Only ' + variant.inv + ' left in stock';
          stockNote.hidden = false;
        } else {
          stockNote.hidden = true;
        }
      }
    }

    box.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
    bundleInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    /* loading feedback on submit */
    var formEl = box.querySelector('form[data-product-form]');
    if (formEl) {
      formEl.addEventListener('submit', function () {
        if (atcBtn && !atcBtn.disabled) {
          atcBtn.textContent = 'Adding…';
          atcBtn.classList.add('is-loading');
        }
      });
    }

    update();

    /* Gallery thumbs */
    var mainImg = box.querySelector('[data-main-image]');
    box.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        box.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Rotating announcement bar ---------- */

  document.querySelectorAll('[data-announcement-rotator]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.announcement__msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      var current = msgs[i];
      i = (i + 1) % msgs.length;
      var next = msgs[i];
      current.style.opacity = '0';
      setTimeout(function () {
        current.hidden = true;
        current.style.opacity = '';
        next.hidden = false;
        next.style.opacity = '0';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { next.style.opacity = '1'; });
        });
      }, 320);
    }, 4500);
  });

  /* ---------- Scroll reveal ---------- */

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var targets = document.querySelectorAll(
      '.benefit, .quote-card, .step, .split-card, .inout-card, .faq__item, .product-card, .trust-bar__item'
    );
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }

  /* ---------- Sticky mobile ATC bar ---------- */

  var sticky = document.querySelector('[data-sticky-atc]');
  if (sticky) {
    var anchor = document.querySelector(sticky.getAttribute('data-watch') || '#buy');
    var shown = false;

    function toggleSticky() {
      var past = window.scrollY > 500;
      var beyondBuybox = true;
      if (anchor) {
        var rect = anchor.getBoundingClientRect();
        /* hide while the buy box CTA itself is on screen */
        beyondBuybox = rect.bottom < 0 || rect.top > window.innerHeight;
      }
      var show = past && beyondBuybox;
      if (show !== shown) {
        shown = show;
        sticky.classList.toggle('is-visible', show);
      }
    }

    window.addEventListener('scroll', toggleSticky, { passive: true });
    toggleSticky();
  }
})();
